export default __webpack_public_path__ + "static/media/no2desc.b3625915.svg";